import { use } from 'react';

import { unstable_useRoute as useRoute } from 'react-router';

import type { CartResult } from '@/shared/types/fetch.types';

/**
 * The cart is streamed from the root route's `clientLoader` as a promise, so
 * these hooks suspend until it resolves — call them inside a `<Suspense>`.
 */
export const useCart = (): CartResult | null => {
  const cartPromise = useRoute('root').loaderData?.cart;
  if (!cartPromise) {
    return null;
  }
  const result = use(cartPromise);
  return result.status === 'ok' ? result.cart : null;
};

export const useCartCount = () => useCart()?.items.length ?? 0;
